import BaseModel from './BaseModel'
import ModelArray from './ModelArray';
import TransactionItem from './TransactionItem'
import VistaDate from './VistaDate';
import MovieService from '../service/movie-service';
export default class Booking extends BaseModel {

    constructor(data = undefined) {
        super(data);
        this.CinemaId = data.CinemaId;
        this.CinemaName = data.CinemaName;
        this.SessionId = data.SessionId;
        this.BookingNumber = data.BookingNumber;
        this.BaseBookingNumber = data.BaseBookingNumber;
        this.BookingRef = data.BookingRef;
        this.MovieName = data.MovieName;
        this.loadingPdf = false;
        this.Barcode = data.Barcode;
        this.DateBooked = data.DateBooked ? new VistaDate(data.DateBooked) : null;
        this.BookingDate = data.BookingDate ? new VistaDate(data.BookingDate) : null;
        this.Movie = {};
        this.EndDate = data.BookingDate ? new VistaDate(data.BookingDate) : null;
        this.VistaTransactionId = data.VistaTransactionId;
        this.Tickets = data.Tickets || [];
        this.MovieSession = {};
        if (this.SessionId) {
            MovieService.findBySessionId(this.SessionId,this.CinemaId).then((movie)=> {
                if (!movie && this.MovieName) {
                    MovieService.findByName(this.MovieName).then((movie)=> {
                        this.Movie = movie;
                        this.MovieSession = this.getSession() || {};
                        this.EndDate = new VistaDate(this.BookingDate.date.clone().add(movie.runtime, 'minutes'));
                    });
                } else {
                    this.Movie = movie;
                    this.MovieSession = this.getSession() || {};
                    this.EndDate = new VistaDate(this.BookingDate.date.clone().add(movie.runtime, 'minutes'));
                }
            });
        }
        this.Concessions = data.Concessions || []
        this.BookingId = data.BookingId
    }


    getSession() {
        if (this.Movie.cinemas) {
            return this.Movie.getSession(this.SessionId);
        }
        return {};
    }


    get Seats() {
        return this.Tickets.map((ticket)=>ticket.SeatRowId + ticket.SeatNumber)
    }

    get SeatString() {

        var string = this.Tickets.reduce((arr, ticket)=> {
            arr[ticket.SeatRowId] = arr[ticket.SeatRowId] || {min:  ticket.SeatNumber, max:  ticket.SeatNumber};
            arr[ticket.SeatRowId].min = arr[ticket.SeatRowId].min > ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].min;
            arr[ticket.SeatRowId].max = arr[ticket.SeatRowId].max < ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].max;
            arr[ticket.SeatRowId].key = ticket.SeatRowId;
            return arr;
        }, {});
        string = Object.keys(string).map(function (key) {
            var ticket = string[key];
            if (ticket.min == ticket.max) {
                return `${ticket.key}${ticket.min}`
            }
            return `${ticket.key}${ticket.min} - ${ticket.key}${ticket.max}`
        }).join(',');


        return string;
    }


}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Booking.js